<template id="napolitano">
  <div class="title">
    {{name}}
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'napolitano',
  data () {
    return {
      name: 'Al Pacino'
    }
  }
}
</script>

<style scoped>
  .title {
    font-size: 5em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Napolitano.vue?3d7a384f